// A capacity bar per day (dorp/dag): registered_count/capacity straight from
// GET /admin/events/{event_id}/registrations's own days[] -- no client-side
// recomputation. A day with no configured capacity shows a plain, unfilled
// "onbeperkt" bar rather than a meaningless percentage.
//
// Extracted out of MultiDayPresence.jsx (where it was originally built) so
// AdminDashboard.jsx can show the exact same per-day meters for a multi-day
// registration event's upcoming days, without a second implementation.
export function dayFillBand(ratio) {
  if (ratio >= 1) return { bar: "bg-rose-500", text: "text-rose-400" };
  if (ratio >= 0.85) return { bar: "bg-amber-500", text: "text-amber-400" };
  return { bar: "bg-emerald-500", text: "text-emerald-400" };
}

export default function DayCapacityBars({ days, testid = "mdr-presence-day-capacity" }) {
  if (!days || days.length === 0) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mb-5" data-testid={testid}>
      {days.map((d) => {
        const count = d.registered_count ?? 0;
        const capacity = d.capacity;
        const hasCapacity = capacity !== null && capacity !== undefined;
        const ratio = hasCapacity && capacity > 0 ? Math.min(count / capacity, 1) : 0;
        const band = hasCapacity ? dayFillBand(count / (capacity || 1)) : { bar: "bg-svj-cyan", text: "text-svj-cyan" };
        return (
          <div
            key={d.id}
            data-testid={`mdr-day-capacity-${d.id}`}
            className="rounded-xl border border-svj-border bg-svj-bg px-3 py-2.5"
          >
            <div className="flex items-baseline justify-between gap-2">
              <div className="min-w-0">
                <div className="text-[11px] uppercase tracking-widest text-slate-500">Dag {d.day_number}</div>
                <div className="text-sm font-medium text-white truncate">{d.label || `Dag ${d.day_number}`}</div>
              </div>
              <div className={`text-sm font-semibold whitespace-nowrap ${band.text}`}>
                {count}
                {hasCapacity ? <span className="text-slate-500 font-normal"> / {capacity}</span> : null}
              </div>
            </div>
            <div className="mt-2 h-2 rounded-full bg-svj-border/60 overflow-hidden">
              {hasCapacity ? (
                <div
                  className={`h-full rounded-full transition-all ${band.bar}`}
                  style={{ width: `${Math.round(ratio * 100)}%` }}
                />
              ) : (
                <div className={`h-full rounded-full ${band.bar} opacity-40`} style={{ width: "100%" }} />
              )}
            </div>
            {!hasCapacity && <div className="mt-1 text-[10px] text-slate-500">Onbeperkt</div>}
            {hasCapacity && ratio >= 1 && <div className="mt-1 text-[10px] text-rose-400">Vol</div>}
          </div>
        );
      })}
    </div>
  );
}
